<template>
  <div>
    <v-server-table
      :url="url"
      @row-click="selectRow($event.row)"
      :columns="columns"
      :options="getOptions"
      :theme="theme"
      ref="table"
      id="dataTable"
    >
      <template v-for="(field, fieldIndex) in columns" v-slot:[field]="slotProps">
        <slot :name="field" :row="slotProps.row">
          {{ slotProps.row[field] }}
        </slot>
      </template>

      <template slot="afterFilter">
        <tr class="VueTables__no-results">
          <b-button @click="resetFilters">Limpiar filtro</b-button>
        </tr>

        <tr v-if="loading" class="VueTables__no-results">
          <b-spinner v-if="loading" variant="primary" class="ml-2 mt-1" small label="Small Spinner" />
        </tr>

        <tr class="VueTables__no-results">
          <download-excel
            v-if="url != '' && downloadeable"
            :name-file="name"
            :headings="!checkJsonEmpty(dwnJsonFields) ? dwnJsonFields : headings"
            :url="url"
          />
        </tr>
      </template>

      <div slot="created_at" slot-scope="props">
        {{ props.row.created_at | humanize_date_time }}
      </div>
      <div slot="clasification" slot-scope="props">
        <b-badge :variant="props.row.color">
          {{ props.row.clasification }}
        </b-badge>
      </div>

      <div slot="name" slot-scope="props">
        <b-badge pill :variant="getBootstrapColorName(props.row.color)">
          {{ props.row.name }}
        </b-badge>
      </div>

      <div slot="net_kilograms" slot-scope="props">
        <div style="text-align: right">
          {{ props.row.net_kilograms | num_format }}
        </div>
      </div>
      <div slot="contents_in_process" slot-scope="props">
        <div>
          {{ props.row.contents_in_process - props.row.contents_consumed }}
        </div>
      </div>
      <template slot="daystay" slot-scope="props">
        <div style="text-align: right">
          <b-badge pill :variant="getDaystayBadge(props.row.daystay)">
            {{ props.row.daystay }}
          </b-badge>
        </div>
      </template>

      <div slot="entered_at" slot-scope="props">
        <div style="text-align: right">
          {{ props.row.entered_at | humanize_date_time }}
        </div>
      </div>

      <div slot="classification" slot-scope="props" v-if="props.row.inspections[0]">
        <div style="text-align: center" class="clickable">
          <modal-qc :id="`modal-qc-${props.row.id}`" :data="props.row.inspections[0] || {}"></modal-qc>
          <b-badge
            pill
            :variant="getBootstrapColorName(props.row.inspections[0].color)"
            @click.prevent="$bvModal.show(`modal-qc-${props.row.id}`)"
          >
            {{ props.row.inspections[0].name }}
          </b-badge>
        </div>
      </div>

      <div slot="left_at" slot-scope="props">
        <div style="text-align: right">
          {{ props.row.left_at | humanize_date_time }}
        </div>
      </div>

      <div slot="tolerancia" slot-scope="props">
        <div style="text-align: right">
          <b-badge
            pill
            :variant="
              getToleranceColor(
                props.row.entered_at,
                props.row.left_at,
                props.row.status.muted_seconds,
                props.row.status.success_seconds,
                props.row.status.warning_seconds,
                props.row.status.danger_seconds
              )
            "
          >
            {{ getElapsedTime(props.row.entered_at, props.row.left_at) }}
          </b-badge>
        </div>
      </div>

      <div slot="last_inspection" slot-scope="props">
        <div v-if="props.row.last_inspection.inspection">
          <span :class="getBadgeInspection(props.row.last_inspection.color_status_pallet)">{{
            props.row.last_inspection.status_pallet
          }}</span>
        </div>
      </div>

      <div slot="date" slot-scope="props">
        {{ props.row.date | moment }}
      </div>

      <div class="text-center" slot="actions" slot-scope="props">
        <span v-for="act in actionButtons" :key="act">
          <a
            target="_blank"
            href="#"
            @click.prevent="$emit(`on-${act}-action`, props.row)"
            :class="`fa fa-lg fa-${act} text-primary mx-2`"
          >
          </a>
        </span>
      </div>

      <!-- <template v-for="(col, index) in columns">
        <template v-slot:[col]="scope">
          <slot :name="'det-' + col" v-bind="scope">
          </slot>
        </template>
      </template> -->
    </v-server-table>
  </div>
</template>

<script>
import Vue from "vue";
import { ServerTable, Event } from "vue-tables-2";
import JsonExcel from "vue-json-excel";
import moment from "moment";
import numeral from "numeral";
import locales from "numeral/locales";
import DownloadExcel from "./DownloadExcel";
import { bus } from "../main";
import { getBootstrapColorName } from "../utils";
import ModalQc from "../views/procesos/produccion/ProductionPlan/ModalQc.vue";

numeral.locale("es");
moment.locale("es");
window.axios = require("axios");

var d = new Date();

Vue.use(ServerTable);
Vue.component("downloadExcel", JsonExcel);

export default {
  name: "StockList",
  props: {
    downloadeable: {
      type: Boolean,
      default: true
    },
    title: {
      type: String,
      default: "Data"
    },
    clickeable: {
      type: Boolean,
      default: false
    },
    column_display: {
      type: Array,
      default: () => []
    },
    columns: {
      type: Array,
      default: []
    },
    url: {
      type: String,
      default: ""
    },
    filterable: {
      type: Array,
      default: []
    },
    headings: {
      type: Object,
      default: {}
    },
    listColumns: {
      type: Object,
      default() {
        return {};
      }
    },
    dwnJsonFields: {
      type: Object,
      default() {
        return {};
      }
    },
    actionButtons: {
      type: Array,
      default: () => []
    },
    tableOptions: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    ServerTable,
    DownloadExcel,
    ModalQc
  },
  created() {
    bus.$off("refreshStockListProcess");
    bus.$on("refreshStockListProcess", () => {
      this.$refs.table.refresh();
    });
  },
  mounted() {
    Event.$on("vue-tables.loading", () => {
      this.loading = true;
      this.$emit("on-loading", true);
    });

    Event.$on("vue-tables.loaded", () => {
      this.loading = false;
      this.$emit("on-loading", false);
    });
  },
  data() {
    return {
      loading: false,
      report: "report",
      selected: [],
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8"
          }
        ]
      ],
      json_fields2: {
        Exportadora: "client_customer_name"
      },
      theme: "bootstrap4",
      template: "default",
      options: {
        skin: "table table-striped table-bordered table-hover table-fixed",
        fixed: true,
        rowClassCallback(row) {
          let row_class = "";
          if (row.in_process) {
            row_class = row.in_process != "" ? "text-strike text-muted" : "";
          }
          if (row.last_inspection) {
            row_class += ` text-${row.last_inspection.color_status_pallet}`;
          }
          if (this.clickeable) {
            row_class += ` clickable`;
          }
          return row_class;
        },
        responseAdapter: function (resp) {
          const results = resp.data.results;
          const items = [];

          for (let key in results) {
            const item = results[key];
            const returnedTarget = Object.assign(item, { active: false });
            items.push(returnedTarget);
          }
          return {
            data: items,
            count: resp.data.count
          };
        },
        texts: {
          noResults: "No se encontraron registros.",
          filter: "Filtrar:",
          filterBy: "Filtrar por {column}",
          count: " ",
          filterPlaceholder: "Buscar...",
          columns: "Columnas",
          limit: "Registros:"
        },
        perPage: 25,
        perPageValues: [15, 25, 50, 100],
        filterByColumn: true,
        filterable: this.filterable,
        headings: this.headings,
        columnsDisplay: this.column_display,
        listColumns: this.listColumns,
        debounce: 1000,
        columnsDropdown: true,
        columnsClasses: {
          quantity: "text-right",
          net_kilograms: "text-right"
        }
      }
    };
  },
  filters: {
    moment(value) {
      return moment(value).format("DD-MM-YYYY");
    },
    humanize_date_time(value) {
      if (value) {
        return moment(value).format("DD-MM-YYYY HH:mm:ss");
      } else {
        return "-";
      }
    },
    num_format(value) {
      value = parseFloat(value);
      return numeral(value).format("0,0.00");
    }
  },
  computed: {
    name() {
      return this.title + " " + moment(Date.now()).format("YYYYMMDD h:mm") + ".xls";
    },
    getOptions() {
      return { ...this.options, ...this.tableOptions };
    }
  },
  methods: {
    getBootstrapColorName,
    checkJsonEmpty(obj) {
      console.log(Object.keys(obj).length === 0 && obj.constructor === Object);
      return Object.keys(obj).length === 0 && obj.constructor === Object;
    },
    getElapsedTime(entered_at, left_at) {
      if (left_at) {
        return moment.duration(moment(left_at).diff(entered_at)).humanize();
      } else {
        return moment(entered_at).startOf("second").fromNow();
      }
    },
    getToleranceColor(entered_at, left_at, muted, success, warning, danger) {
      if (left_at) {
        var end = moment(left_at);
      } else {
        var end = moment();
      }
      var duration = moment.duration(end.diff(entered_at)).asSeconds();
      var result = "secondary";
      if (duration > danger) {
        result = "danger";
      } else if (duration > warning) {
        result = "warning";
      } else if (duration > success) {
        result = "success";
      } else if (duration > muted) {
        result = "secondary";
      }
      return result;
    },
    getDaystayBadge(daystay) {
      return daystay >= 10 ? "danger" : daystay >= 5 ? "warning" : daystay >= 3 ? "success" : "primary";
    },
    getBadgeInspection(color) {
      return `badge badge-${color}`;
    },
    selectRow(row) {
      this.$emit("select-row", row);
      this.selected.push(row);
      // this.$refs["table"].refresh();
      //row.active = true;
    },
    jsonToQueryString(json) {
      var result = {};
      for (var key in json) {
        if (json[key] !== "") {
          result[key] = json[key];
        }
      }
      var a = encodeURIComponent(JSON.stringify(result));
      return "/api/v1/stock/?query=" + a;
    },
    resetFilters() {
      for (var key in this.$refs["table"].query) {
        this.$refs["table"].query[key] = "";
      }
      this.$refs["table"].refresh();
    },

    async fetchData() {
      const response = await this.$axios.get(this.jsonToQueryString(this.$refs.table.query));
      return response.data.results;
    },
    startDownload() {
      this.loading = true;
    },
    finishDownload() {
      this.loading = false;
    }
  }
};
</script>

<style>
.clickable {
  cursor: pointer;
}
#dataTable {
  width: 100%;
  margin: 0 auto;

  tr.text-strike {
    text-decoration: line-through;
  }

  .VuePagination {
    text-align: center;
    justify-content: center;
  }

  .table td {
    padding: 0.3em;
  }

  .vue-title {
    text-align: center;
    margin-bottom: 10px;
  }

  .VueTables__search-field {
    display: flex;
  }

  .VueTables__search-field input {
    margin-left: 0.12rem;
  }

  .VueTables__limit-field {
    display: flex;
  }

  .VueTables__limit-field select {
    margin-left: 0.25rem !important;
  }

  .VueTables__table th {
    text-align: center;
    padding: 0.25rem;
  }

  .VueTables__child-row-toggler {
    width: 16px;
    height: 16px;
    line-height: 16px;
    display: block;
    margin: auto;
    text-align: center;
  }

  .VueTables__child-row-toggler--closed::before {
    content: "+";
  }

  .VueTables__columns-dropdown {
    padding-right: 20px;
  }

  .VueTables__date-filter {
    border: 1px solid #ccc;
    padding: 6px;
    border-radius: 4px;
    cursor: pointer;
  }

  .VueTables__number-field {
    border: 4px solid #ccc;
    padding: 6px;
    border-radius: 4px;
    cursor: pointer;
  }

  .VueTables__child-row-toggler--open::before {
    content: "-";
  }
}
</style>
